const Modal = () => {
  // Teleport modals to body to escape contain/transform containing blocks
  for (const modal of document.querySelectorAll('.js-modal')) {
    document.body.appendChild(modal);
  }

  const triggers = document.querySelectorAll('.js-modal-close');

  for (const trigger of triggers) {
    const modal = trigger.closest('.js-modal');

    const handler = () => {
      if (modal) {
        modal.classList.remove('-open');
      }
    };

    trigger.addEventListener('click', handler);
  }
};

export default Modal;
